import React from 'react';
import { Form } from 'src/core/forms';
import { Modal } from 'src/components/Modal/Modal';
import { Input } from 'src/components/Forms/Input';
import { TextArea } from 'src/components/Forms/TextArea';
import { Actions } from 'src/components/Forms/Actions';
import { basicEmailValidation, basicPresenceValidation, telephoneValidation } from 'src/util/forms';
import { DataStatus } from 'src/core/engine/types';
import { Button } from 'src/components/Button/Button';
import { ModalFooter } from 'src/components/Modal/ModalFooter';
import { Messages } from 'src/components/Messages/Messages';

import { Fieldset } from '../../components/Forms/Fieldset';
import { Svg } from '../../components/Svg/Svg';

import { useQuickQuote } from './useQuickQuote';
import classes from './QuickQuote.scss';

type QuoteProps = {
    sku: string;
    close: () => void;
    quoteOpen: boolean;
};

const Quote: React.FC<QuoteProps> = ({ sku, close, quoteOpen }) => {
    const { state, submit } = useQuickQuote();
    const isPending = state.status === DataStatus.Pending;

    if (state.messages.length > 0) {
        state.messages.map((msg) => {
            if (msg.type === 'Success') {
                setTimeout(() => close(), 2000);
                return (msg.text = 'Thanks! One of our team will be in touch shortly');
            }
        });
    }

    return (
        <Modal isOpen={quoteOpen}>
            <header className={classes.quickQuoteModalHeader}>
                <h2 className={classes.quickQuoteTitle} data-test-id="Quick-quote-title">
                    Quick Quote
                </h2>
                <Button
                    onClick={close}
                    variant="reset"
                    className={classes.quickQuoteModalHeaderClose}
                    aria-label="Close"
                >
                    <Svg name="close" />
                </Button>
            </header>
            <Form onSubmit={(values) => submit(values, sku)} data-test-id="Quick-quote-form" autoComplete="off">
                <Fieldset disabled={isPending}>
                    <Input
                        label="Full Name"
                        field="name"
                        id="name"
                        validate={basicPresenceValidation()}
                        required
                        disableAutoComplete
                    />
                    <Input
                        label="Phone Number"
                        field="telephone"
                        id="telephone"
                        type="number"
                        validate={telephoneValidation()}
                        required
                        disableAutoComplete
                    />
                    <Input
                        label="Email Address"
                        field="email"
                        id="email"
                        validate={basicEmailValidation()}
                        required
                        disableAutoComplete
                    />
                    <TextArea
                        field="message"
                        id="message"
                        label="How can we help you?"
                        validate={basicPresenceValidation()}
                        required
                    />
                </Fieldset>
                <ModalFooter
                    onDismiss={close}
                    confirmBtn={<Actions primaryText="Get Quote" primaryVariant="secondary" icon="flash2" />}
                />
                {state.messages.length > 0 && (
                    <div className={classes.contactFormMessages} data-test-id="ContactFormMessages">
                        <Messages messages={state.messages} />
                    </div>
                )}
            </Form>
        </Modal>
    );
};

export default Quote;
